module.exports = __webpack_public_path__ + "img/1L2.5b3bff3d.png";